import React from 'react';
import { Box, IconButton, Tab, Tabs, Tooltip } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';

const WorkflowFlowHeader = ({
  sortedFlows,
  fallbackFlowId,
  onSelectFlow,
  onCreateFlow,
  onRenameFlow,
  onDeleteFlow,
  canDeleteSelectedFlow,
  t,
}) => {
  const flowList = sortedFlows || [];
  const activeTabValue =
    fallbackFlowId !== null && fallbackFlowId !== undefined
      ? String(fallbackFlowId)
      : (flowList[0] ? String(flowList[0].id) : false);
  const handleRenameIconClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    onRenameFlow?.();
  };
  const handleDeleteIconClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (canDeleteSelectedFlow) {
      onDeleteFlow?.();
    }
  };

  return (
    <Box sx={{ mb: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'flex-end', minWidth: 0 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', minWidth: 0, maxWidth: '100%' }}>
          <Tabs
            value={activeTabValue}
            onChange={(_, newValue) => {
              const matchedFlow = flowList.find((flow) => String(flow.id) === String(newValue));
              if (matchedFlow) {
                onSelectFlow(matchedFlow.id);
              }
            }}
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            sx={{
              flex: '0 1 auto',
              minWidth: 0,
              minHeight: 38,
              '& .MuiTab-root': {
                minHeight: 38,
                textTransform: 'none',
                py: 0.5,
                px: 1.5,
                mr: 0.5,
                borderRadius: '10px 10px 0 0',
              },
            }}
          >
            {flowList.map((flow) => (
              <Tab
                key={flow.id}
                value={String(flow.id)}
                label={(
                  <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5 }}>
                    <span>{flow.name || t('workflow.unnamed_flow', 'Flow')}</span>
                    {String(flow.id) === String(activeTabValue) && (
                      <Box
                        sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.25 }}
                        onMouseDown={(event) => {
                          event.preventDefault();
                          event.stopPropagation();
                        }}
                        onClick={(event) => {
                          event.preventDefault();
                          event.stopPropagation();
                        }}
                      >
                        <Tooltip title={t('workflow.rename_flow', 'Rename')}>
                          <IconButton
                            size="small"
                            onClick={handleRenameIconClick}
                            aria-label={t('workflow.rename_flow', 'Rename')}
                            sx={{ p: 0.5 }}
                          >
                            <EditIcon sx={{ fontSize: 18 }} />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title={t('workflow.delete_flow', 'Delete')}>
                          <span>
                            <IconButton
                              size="small"
                              color="error"
                              onClick={handleDeleteIconClick}
                              disabled={!canDeleteSelectedFlow}
                              aria-label={t('workflow.delete_flow', 'Delete')}
                              sx={{ p: 0.5 }}
                            >
                              <DeleteIcon sx={{ fontSize: 18 }} />
                            </IconButton>
                          </span>
                        </Tooltip>
                      </Box>
                    )}
                  </Box>
                )}
              />
            ))}
          </Tabs>
          <Tooltip title={t('workflow.create_flow', 'Create flow')}>
            <IconButton
              size="small"
              onClick={onCreateFlow}
              aria-label={t('workflow.create_flow', 'Create flow')}
              sx={{
                width: 34,
                height: 34,
                ml: 0.5,
                mb: 0.25,
                flexShrink: 0,
                border: '1px solid rgba(87, 87, 176, 0.36)',
                borderRadius: '8px',
                color: '#5757b0',
                backgroundColor: '#fff',
                '&:hover': {
                  borderColor: '#5757b0',
                  backgroundColor: '#f4f3ff'
                }
              }}
            >
              <AddIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Box>
      </Box>
    </Box>
  );
};

export default WorkflowFlowHeader;
